import { useCallback, useState } from 'react';

import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useFormikContext } from 'formik';

import { Block } from 'components/page';
import { ListagemProvider } from 'context/ListagemContext';
import { PermissoesPanelTitle, PermissoesUsuariosGrid, PermissoesUsuariosModal } from 'pages/cadastro/permissoes/components';
import { PermissoesProps } from 'pages/cadastro/permissoes/types';

export function PermissoesUsuariosPanel() {
    const { values, setFieldValue } = useFormikContext<PermissoesProps>();

    const [openUsuarioModal, setOpenUsuarioModal] = useState(false);
    const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });

    /**
     * Remove os usuários selecionados na grid.
     */
    const handleRemoveSelected = useCallback(() => {
        const selectedIds = selectionModel.ids;

        if (selectedIds.size === 0) return;

        const usuarios = (values.usuarios || []).filter((u) => !selectedIds.has(u.idUsuario));
        setFieldValue('usuarios', usuarios);

        setSelectionModel({ type: 'include', ids: new Set() });
    }, [selectionModel, values.usuarios, setFieldValue]);

    return (
        <>
            <PermissoesUsuariosModal open={openUsuarioModal} setOpen={setOpenUsuarioModal} />

            <Block sx={{ 'p': 0, 'overflow': 'hidden', '&>div': { border: 'none' } }}>
                <PermissoesPanelTitle
                    title="Usuários"
                    extraContent={
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {selectionModel.ids.size > 0 && (
                                <Button variant="outlined" sx={{ color: 'common.white', px: 1 }} onClick={handleRemoveSelected}>
                                    Excluir selecionados
                                </Button>
                            )}

                            <Button variant="outlined" sx={{ color: 'common.white', mr: -1, px: 1 }} onClick={() => setOpenUsuarioModal(true)}>
                                Adicionar usuários
                            </Button>
                        </Box>
                    }
                />

                <ListagemProvider>
                    <PermissoesUsuariosGrid selectionModel={selectionModel} setSelectionModel={setSelectionModel} />
                </ListagemProvider>
            </Block>
        </>
    );
}
